<script>
	import stockup from './stockup.vue'
	export default {
		extends: stockup,
		data() {
			return {
				notice:'系统自动排查【应急商品】1小时更新一次',
				listref:"stockWarningEmergentList",
				policytype:312
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
		components: {

		}
	}
</script>